/**
 * [KA] Cart drawer — companion to sections/ka-cart-drawer.liquid.
 *
 * The section claims id="cart-drawer" from the header group, which is parsed
 * before the core drawer render at the end of layout/theme.liquid, so every
 * lookup (trigger on:click="#cart-drawer/toggle", aria-controls, session
 * restore, Shopify.actions.openCart) already resolves to the KA drawer. This
 * module removes the now-shadowed core drawer node so the page never carries
 * two dialogs / duplicate ids — and puts it back if the section is removed in
 * the theme editor.
 */

const CORE_WRAPPER_ID = 'shopify-section-cart-drawer-section';
const KA_DRAWER_SELECTOR = 'theme-drawer[data-ka-cart-drawer]';

let detachedCoreDrawer = null;
let placeholder = null;

function detachCoreDrawer() {
  if (detachedCoreDrawer) return;

  const coreWrapper = document.getElementById(CORE_WRAPPER_ID);
  if (!coreWrapper || !document.querySelector(KA_DRAWER_SELECTOR)) return;

  placeholder = document.createComment('ka-cart-drawer: core cart drawer detached');
  coreWrapper.replaceWith(placeholder);
  detachedCoreDrawer = coreWrapper;
}

function reattachCoreDrawer() {
  if (!detachedCoreDrawer || !placeholder) return;

  placeholder.replaceWith(detachedCoreDrawer);
  detachedCoreDrawer = null;
  placeholder = null;
}

detachCoreDrawer();

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector(KA_DRAWER_SELECTOR)) detachCoreDrawer();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector(KA_DRAWER_SELECTOR)) reattachCoreDrawer();
  });

  // Selecting the section in the editor opens the drawer so the merchant can
  // see what they are editing; deselecting closes it again. theme-drawer owns
  // the dialog lifecycle (open/close/isOpen — see assets/theme-drawer.js).
  document.addEventListener('shopify:section:select', async (event) => {
    const drawer = event.target.querySelector(KA_DRAWER_SELECTOR);
    if (!drawer) return;

    await customElements.whenDefined('theme-drawer');
    if (typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
  });

  document.addEventListener('shopify:section:deselect', async (event) => {
    const drawer = event.target.querySelector(KA_DRAWER_SELECTOR);
    if (!drawer) return;

    await customElements.whenDefined('theme-drawer');
    if (typeof drawer.close === 'function' && drawer.isOpen) drawer.close();
  });
}
